// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609101305/js/" + chunkId + "." + {"44":"945b7359","225":"3330a6fe","481":"c2f2384a","486":"d9e442ff","770":"0bb02fac"}[chunkId] + ".0.6474070771419969.chunk.js";
};